const ResultManager = () => import("@/pages/lab/resultmanager/ResultManager");
const ResultManagerDetail = () => import("@/pages/lab/resultmanager/ResultManagerDetail");
const ResultManagerEdit = () => import("@/pages/lab/resultmanager/ResultManagerEdit");
const ResultManagerAuditTrailHistory = () => import("@/pages/lab/resultmanager/ResultManagerAuditTrailHistory");

export class ResultManagerRoutes {

    constructor() {
        this.route_root = "result-manager";
        this.type_singular = "Result Manager";
        this.type_plural = "Result Manager";

        this.routes = [
            {
                path: this.route_root,
                component: {
                    render(c) {
                        return c("router-view");
                    }
                },
                redirect: this.route_root,
                name: this.type_plural,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: "",
                        component: ResultManager,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ":analyte_result_id",
                        name: `View ${this.type_singular}`,
                        component: { render (c) { return c('router-view') } },
                        redirect: ":analyte_result_id",
                        meta: { requiresAuth: true },
                        children: [
                            {
                                path: '',
                                component: ResultManagerDetail,
                                meta: { requiresAuth: true }
                            },
                            {
                                path: 'edit',
                                name: 'Edit Result',
                                component: ResultManagerEdit,
                                meta: { requiresAuth: true }
                            },
                            {
                                path: 'audit-trail-history',
                                name: 'Audit Trail History',
                                component: ResultManagerAuditTrailHistory,
                                meta: { requiresAuth: true }
                            }
                        ]
                    }
                ]
            }
        ];

        this.public_routes = [];
    }

    static fetchRoutes() {
        let this_obj = new this();
        return this_obj.routes;
    }

    static fetchPublicRoutes() {
        let this_obj = new this();
        return this_obj.public_routes;
    }

}